export default __webpack_public_path__ + "static/media/grafema_armazem-da-alfandega_10.2388e8b9.jpg";